import {ChangeDetectionStrategy, Component} from "@angular/core";
import {HeaderComponent} from "../../components/header/header.component";
import {ResetPasswordFormComponent} from "../../components/reset-password-form/reset-password-form.component";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, ResetPasswordFormComponent],
})
export class ResetPasswordComponent {}
